import { render } from "./NotePad.vue?vue&type=template&id=34c6070f"
import script from "./NotePad.vue?vue&type=script&lang=js"
export * from "./NotePad.vue?vue&type=script&lang=js"

import "./NotePad.vue?vue&type=style&index=0&id=34c6070f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__